<template>
   <div id="container">
      <mvtHeader />
      <div class="static-section">
         <div class="static-gs">
            <div class="word-section">
               <h1>{{molang('termsofuse.title')}}</h1>
               <h2>{{molang('termsofuse.subTitle1')}}</h2>
               <p>
                  <b>{{molang('termsofuse.descriptionOfService.header')}}</b>
                  <span v-html="getContent('termsofuse.descriptionOfService.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.bindingAgreement.header')}}</b>
                  <span v-html="getContent('termsofuse.bindingAgreement.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.gdpr.header')}}</b>
                  <span v-html="getContent('termsofuse.gdpr.content')"></span>
               </p>
               <h2>{{molang('termsofuse.disclaimersOfWarranty.header')}}</h2>
               <p>{{molang('termsofuse.disclaimersOfWarranty.subheader')}}</p>
               <p>
                  <span v-html="getContent('termsofuse.disclaimersOfWarranty.content1')"></span>
               </p>
               <p>
                  <span v-html="getContent('termsofuse.disclaimersOfWarranty.content2')"></span>
               </p>
               <h2>{{molang('termsofuse.limitationOfLiability.header')}}</h2>
               <p>{{molang('termsofuse.limitationOfLiability.subheader')}}</p>
               <p>
                  <span v-html="getContent('termsofuse.limitationOfLiability.content1')"></span>
               </p>
               <p>
                  <span v-html="getContent('termsofuse.limitationOfLiability.content2')"></span>
               </p>
               <h2>{{molang('termsofuse.exclusions.header')}}</h2>
               <p>
                  <span v-html="getContent('termsofuse.exclusions.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.privacyPolicy.header')}}</b>
                  <span v-html="getContent('termsofuse.privacyPolicy.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.disclosure.header')}}</b>
                  <span v-html="getContent('termsofuse.disclosure.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.thirdPartyContent.header')}}</b>
                  <span v-html="getContent('termsofuse.thirdPartyContent.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.yourConduct.header')}}</b>
                  <span v-html="getContent('termsofuse.yourConduct.subheader')"></span>
               </p>
               <ul>
                  <li v-html="getContent('termsofuse.yourConduct.item1')"></li>
                  <li v-html="getContent('termsofuse.yourConduct.item2')"></li>
                  <li v-html="getContent('termsofuse.yourConduct.item3')"></li>
                  <li v-html="getContent('termsofuse.yourConduct.item4')"></li>
                     <ul>
                        <li v-html="getContent('termsofuse.yourConduct.item4a')"></li>
                        <li v-html="getContent('termsofuse.yourConduct.item4b')"></li>
                        <li v-html="getContent('termsofuse.yourConduct.item4c')"></li>
                     </ul>
                  <li v-html="getContent('termsofuse.yourConduct.item5')"></li>
               </ul>
               <p>
                  <b>{{molang('termsofuse.termination.header')}}</b>
                  <span v-html="getContent('termsofuse.termination.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.minimumAgeLimit.header')}}</b>
                  <span v-html="getContent('termsofuse.minimumAgeLimit.content')"></span>
               </p>
               <h2>{{molang('termsofuse.subTitle2')}}</h2>
               <p>
                  <b>{{molang('termsofuse.realEstateClients.header')}}</b>
                  <span v-html="getContent('termsofuse.realEstateClients.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.realEstateData.header')}}</b>
                  <span v-html="getContent('termsofuse.realEstateData.content1')"></span>
               </p>
               <div v-html="getContent('termsofuse.realEstateData.content2')"></div>
               <ul>
                  <li v-html="getContent('termsofuse.realEstateData.item1')"></li>
                  <li v-html="getContent('termsofuse.realEstateData.item2')"></li>
                  <li v-html="getContent('termsofuse.realEstateData.item3')"></li>
                  <li v-html="getContent('termsofuse.realEstateData.item4')"></li>
               </ul>
               <p>
                  <b>{{molang('termsofuse.financialMortgageTools.header')}}</b>
                  <b v-html="getContent('termsofuse.financialMortgageTools.content')"></b>
               </p>
               <h3>{{molang('termsofuse.limitationsAutomatedValuationModels.header')}}</h3>
               <ul>
                  <li v-html="getContent('termsofuse.limitationsAutomatedValuationModels.content1')"></li>
                  <li v-html="getContent('termsofuse.limitationsAutomatedValuationModels.content2')"></li>
                  <li v-html="getContent('termsofuse.limitationsAutomatedValuationModels.content3')"></li>
                  <li v-html="getContent('termsofuse.limitationsAutomatedValuationModels.content4')"></li>
                  <li v-html="getContent('termsofuse.limitationsAutomatedValuationModels.content5')"></li>
               </ul>
               <p>
                  <b>{{molang('termsofuse.otherParties.header')}}</b>
                  <span v-html="getContent('termsofuse.otherParties.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.promotionalRates.header')}}</b>
                  <span v-html="getContent('termsofuse.promotionalRates.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.intellectualPropertyRights.header')}}</b>
                  <span v-html="getContent('termsofuse.intellectualPropertyRights.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.copyright.header')}}</b>
                  <span v-html="getContent('termsofuse.copyright.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.trademark.header')}}</b>
                  <span v-html="getContent('termsofuse.trademark.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.patent.header')}}</b>
                  <span v-html="getContent('termsofuse.patent.content')"></span>
               </p>
               <h2>{{molang('termsofuse.subTitle3')}}</h2>
               <p>
                  <b>{{molang('termsofuse.yourRights.header')}}</b>
                  <span v-html="getContent('termsofuse.yourRights.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.responsibilityYourContent.header')}}</b>
                  <span v-html="getContent('termsofuse.responsibilityYourContent.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.ourRightUseYourContent.header')}}</b>
                  <span v-html="getContent('termsofuse.ourRightUseYourContent.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.ownership.header')}}</b>
                  <span v-html="getContent('termsofuse.ownership.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.advertising.header')}}</b>
                  <span v-html="getContent('termsofuse.advertising.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.other.header')}}</b>
                  <span v-html="getContent('termsofuse.other.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.restrictions.header')}}</b>
                  <span v-html="getContent('termsofuse.restrictions.content1')"></span>
               </p>
               <ol type="a">
                  <li v-html="getContent('termsofuse.restrictions.item1')"></li>
                     <ol type="1">
                        <li v-html="getContent('termsofuse.restrictions.item1a')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item1b')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item1c')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item1d')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item1e')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item1f')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item1g')"></li>
                     </ol>
                  <li v-html="getContent('termsofuse.restrictions.item2')"></li>
                     <ol type="1">
                        <li v-html="getContent('termsofuse.restrictions.item2a')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item2b')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item2c')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item2d')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item2e')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item2f')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item2g')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item2h')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item2i')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item2j')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item2k')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item2l')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item2m')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item2n')"></li>
                        <li v-html="getContent('termsofuse.restrictions.item2o')"></li>
                     </ol>
               </ol>
               <p>
                  <span v-html="getContent('termsofuse.restrictions.content2')"></span>
               </p>

               <h2>{{molang('termsofuse.guidelinesPolicies.header')}}</h2>
               <ol>
                  <li v-html="getContent('termsofuse.guidelinesPolicies.content1')"></li>
                  <li v-html="getContent('termsofuse.guidelinesPolicies.content2')"></li>
               </ol>

               <p>
                  <b>{{molang('termsofuse.copyrightInfringement.header')}}</b>
                  <span v-html="getContent('termsofuse.copyrightInfringement.content1')"></span>
               </p>
               <p>
                  <span v-html="getContent('termsofuse.copyrightInfringement.address1')"></span>
               </p>
               <p>
                  <span v-html="getContent('termsofuse.copyrightInfringement.address2')"></span>
               </p>
               <p>
                  <span v-html="getContent('termsofuse.copyrightInfringement.address3')"></span>
               </p>
               <p>
                  <span v-html="getContent('termsofuse.copyrightInfringement.address4')"></span>
               </p>
               <p>
                  <span v-html="getContent('termsofuse.copyrightInfringement.content2')"></span>
               </p>

               <ol>
                  <li v-html="getContent('termsofuse.copyrightInfringement.item1')"></li>
                  <li v-html="getContent('termsofuse.copyrightInfringement.item2')"></li>
                  <li v-html="getContent('termsofuse.copyrightInfringement.item3')"></li>
                  <li v-html="getContent('termsofuse.copyrightInfringement.item4')"></li>
                  <li v-html="getContent('termsofuse.copyrightInfringement.item5')"></li>
                  <li v-html="getContent('termsofuse.copyrightInfringement.item6')"></li>
               </ol>

               <p>
                  <b>{{molang('termsofuse.indemnification.header')}}</b>
                  <span v-html="getContent('termsofuse.indemnification.content')"></span>
               </p>
               <h2>{{molang('termsofuse.subTitle4')}}</h2>
               <p>
                  <b>{{molang('termsofuse.claimingProfiles.header')}}</b>
                  <span v-html="getContent('termsofuse.claimingProfiles.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.authorization.header')}}</b>
                  <span v-html="getContent('termsofuse.authorization.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.communications.header')}}</b>
                  <span v-html="getContent('termsofuse.communications.content')"></span>
               </p>
               <p>
                  <b>{{molang('termsofuse.informationDisplay.header')}}</b>
                  <span v-html="getContent('termsofuse.informationDisplay.content')"></span>
               </p>
               <h2>{{molang('termsofuse.subTitle5')}}</h2>
               <p>
                  <i><span>{{molang('termsofuse.entireAgreement.header')}}</span></i>
                  <span v-html="getContent('termsofuse.entireAgreement.content')"></span>
               </p>
               <p>
                  <i><span>{{molang('termsofuse.applicableLaw.header')}}</span></i>
                  <span v-html="getContent('termsofuse.applicableLaw.content')"></span>
               </p>
               <p>
                  <i><span>{{molang('termsofuse.waiver.header')}}</span></i>
                  <span v-html="getContent('termsofuse.waiver.content')"></span>
               </p>
               <p>
                  <i><span>{{molang('termsofuse.severability.header')}}</span></i>
                  <span v-html="getContent('termsofuse.severability.content')"></span>
               </p>
               <p>
                  <i><span>{{molang('termsofuse.statuteLimitations.header')}}</span></i>
                  <span v-html="getContent('termsofuse.statuteLimitations.content')"></span>
               </p>
               <p>
                  <i><span>{{molang('termsofuse.relationship.header')}}</span></i>
                  <span v-html="getContent('termsofuse.relationship.content')"></span>
               </p>
               <p>
                  <i><span>{{molang('termsofuse.forceMajeure.header')}}</span></i>
                  <span v-html="getContent('termsofuse.forceMajeure.content')"></span>
               </p>
               <h2 class="f4" id="affiliates">{{molang('termsofuse.subTitle6')}}</h2>
               <p><span v-html="getContent('termsofuse.affiliates.content')"></span></p>
               <h2>{{molang('termsofuse.affiliates.affiliates1.header')}}</h2>

               <ol>
                  <li v-html="getContent('termsofuse.affiliates.affiliates1.item1')"></li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates1.item2')"></li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates1.item3')"></li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates1.item4')"></li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates1.item5')"></li>
               </ol>

               <h2>{{molang('termsofuse.affiliates.affiliates2.header')}}</h2>

               <ol>
                  <li v-html="getContent('termsofuse.affiliates.affiliates2.item1')"></li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates2.item2')"></li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates2.item3')"></li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates2.item4')"></li>
               </ol>

               <h2>{{molang('termsofuse.affiliates.affiliates3.header')}}</h2>

               <ol>
                  <li v-html="getContent('termsofuse.affiliates.affiliates3.item1')"></li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates3.item2')"></li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates3.item3')"></li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates3.item4')"></li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates3.item5')"></li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates3.item6')"></li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates3.item7')"></li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates3.item8')"></li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates3.item9')"></li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates3.item10')"></li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates3.item11')"></li>
               </ol>

               <h2>{{molang('termsofuse.affiliates.affiliates4.header')}}</h2>

               <ol>
                  <li v-html="getContent('termsofuse.affiliates.affiliates4.item2')"></li>
                  <li>Zumper, Inc.</li>
                  <li v-html="getContent('termsofuse.affiliates.affiliates4.item3')"></li>
               </ol>

               <h2 class="f4">Additional Terms and Conditions of Use for Rental Listings</h2>
               <p>
                  From time to time, the Site may display listings for rental properties (“Rental Listings”).
                  Rental Listings are provided to Movoto by Zumper, Inc.
                  Movoto is compensated by Zumper for consumers completing a lead form contained in a Rental Listing.
                  Users completing a lead form will either be directed to a Zumper website or contacted by Zumper.
                  Users’ interactions with Zumper will be governed by Zumper’s Terms and Conditions (available at: <a class="link" href="https://www.zumper.com/terms-and-conditions" target="_blank" rel="nofollow noreferrer">Terms and Conditions - Zumper </a>) and Privacy Policy (available at: <a class="link" href="https://www.zumper.com/privacy-policy" target="_blank" rel="nofollow noreferrer">Privacy Policy - Zumper</a> ).
               </p>
               <p>
                  Movoto does not, and the information contained in the Rental Listings are not intended to, provide financial services or real estate services to you.
                  By providing Rental Listings on the Site, Movoto does not (i) act as a property manager, broker, or agent; or (ii) broker, lease, or sublease or offer to broker, lease or sublease, or own any Rental Listings.
                  Movoto is not a party to any agreement or transaction relating to any Rental Listing.
               </p>
                <p>
                   Movoto does not counsel parties to any rental transaction, assess the qualifications of potential tenants, show properties, or negotiate rental or sales contracts on or through the Site or any information contained in any Rental Listing.
                   No brokerage relationship or any agency or fiduciary relationship is intended to be or shall be deemed to have been created between Movoto and any user of the Site or viewer of any Rental Listing.
                   Additionally, rental and lease transactions are complicated and are governed by various laws, practices and customs. Users are advised to seek the help of a licensed real estate professional and/or a real estate attorney to help in the negotiation and completion of any lease or rental agreement.
                </p>
               <p>
                  <span>
                     Copyright © 2005 - {{currentFullYear}} Movoto, Inc. All rights reserved.
                  </span>
               </p>
            </div>
         </div>
      </div>
      <mvtFooter />
      <mvtDialogCenter></mvtDialogCenter>
   </div>
</template>
<script src="./termsofuse.js"></script>
<style lang="scss">
   @use './termsofuse.scss' as *;
</style>
